(function () {
    const articleActionsbar = {
        init() {
            articleActionsbar.set.variables();
            articleActionsbar.hideBtnsOrDisableSelect();
            articleActionsbar.controls();
        },
        set: {
            variables() {
                articleActionsbar.form = document.getElementById('frmIssueItems');
                articleActionsbar.checkboxes = document.querySelectorAll('.issue-Item__checkbox');
                articleActionsbar.btns = document.querySelectorAll('.article-actionbar__btn');
                articleActionsbar.btnsContainer = document.querySelector('.article-actionbar__btns');
                articleActionsbar.selectAllBox = document.querySelector('.article-actionbar__check-all input');
                articleActionsbar.hideActionsClass = 'article-actionbar__btns--hide';
                articleActionsbar.bulkAction = document.querySelector('.article-actionbar__btns__select')
                    ? document.querySelector('.article-actionbar__btns__select')
                    : '';
            },
        },
        controls() {
            if (config.enableArticleActionbarSelectAll) {
                articleActionsbar.selectAllBox.addEventListener('click', function () {
                    const isChecked = this.checked;
                    articleActionsbar.checkboxes.forEach(item => (item.checked = isChecked));
                    articleActionsbar.hideBtnsOrDisableSelect();
                });
            }

            articleActionsbar.checkboxes.forEach(elem => {
                elem.addEventListener('click', () => {
                    articleActionsbar.selectAllBox.checked = articleActionsbar.allItemsSelected();
                    articleActionsbar.hideBtnsOrDisableSelect();
                });
            });

            articleActionsbar.btns.forEach(elem => {
                if (!(articleActionsbar.bulkAction.length > 0)) {
                    elem.addEventListener('click', function (e) {
                        const _this = this;
                        e.preventDefault();
                        if (!_this.hasAttribute('data-toggle') && _this.nodeName !== 'OPTION') {
                            articleActionsbar.form.action = _this.href;
                            articleActionsbar.form.submit();
                        }
                    });
                } else {
                    articleActionsbar.bulkAction.addEventListener('change', function (e) {
                        const _this = this;
                        if (!articleActionsbar.form.length || !articleActionsbar.hasSelectedItems()) {
                            return;
                        }
                        articleActionsbar.form.action = _this.value;
                        articleActionsbar.form.submit();
                    });
                }
            });
        },
        allItemsSelected() {
            return Array.from(articleActionsbar.checkboxes).every(item => {
                return item.checked;
            });
        },
        hasSelectedItems() {
            return Array.from(articleActionsbar.checkboxes).some(item => {
                return item.checked;
            });
        },
        showHideActionBtns() {
            if (!articleActionsbar.hasSelectedItems()) {
                articleActionsbar.btnsContainer.classList.add(articleActionsbar.hideActionsClass);
            } else {
                articleActionsbar.btnsContainer.classList.remove(articleActionsbar.hideActionsClass);
            }
        },
        hideBtnsOrDisableSelect() {
            if (!(articleActionsbar.bulkAction.length > 0)) {
                articleActionsbar.showHideActionBtns();
            } else {
                articleActionsbar.validateBulkActions();
            }
        },
        validateBulkActions() {
            articleActionsbar.bulkAction.toggleAttribute('disabled', !articleActionsbar.hasSelectedItems());
        },
    };

    UX.articleActionsbar = articleActionsbar;
    document.addEventListener('DOMContentLoaded', () => {
        if (document.querySelector('.article-actionbar')) {
            UX.articleActionsbar.init();
        }
    });
})();
